// extracted by mini-css-extract-plugin
export default {"title":"enable_title__iZTXm","buttonPart":"enable_buttonPart__RlLzk","buttonCancel":"enable_buttonCancel__kQKzk","buttonEnable":"enable_buttonEnable__xzVy8"};